<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Entry or Exit Flow Graph"
    [pathBreadcrumbs]="toolListService.getHelpPagePathBreadcrumbs('entry_exit')"
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Exit or Entry Flow
      Graph Tool. The Entry and Exit Flow Graph Tool displays student flow in
      and out of a program [Forward: Flow out; Backward: Flow in]
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Admin Support Section
          <i class="fa-solid fa-arrow-right"></i> Entry or Exit Flow Graph
        </h1>

        <div class="buttons-nav">
          <div class="example-button-row">
            <nav-page-link
              text="Entry/Exit Filter Guide"
              targetId="formguide"
              tooltipMessage="Navigate down"
            ></nav-page-link>
            <span> &nbsp; | &nbsp; </span>
            <nav-page-link
              text="Entry or Exit Flow Graph Result"
              targetId="results"
              tooltipMessage="Navigate down"
            ></nav-page-link>
          </div>
        </div>

        <!---------- Entry or Exit Flow Graph Tool At First Glance ---------->
        <h3 class="h3-second-header">
          Entry or Exit Flow Graph Tool At First Glance
        </h3>

        <ol class="ordered-list">
          <li>
            Once you get to the page, you will be able to see something like the
            image below in Figure 39.
          </li>
        </ol>

        <div>
          <br />
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageEntryExitFlow39']"
            alt=""
          />
          <p class="picture-caption">
            Figure 39: Entry or Exit Flow Graph Tool Page
          </p>
        </div>

        <div id="formguide"></div>
        <br />
        <mat-divider></mat-divider>
        <br />
      </div>

      <!---------- Entry or Exit Flow Graph Form Guide ---------->
      <div class="left-align-div">
        <h3 class="h3-second-header">
          Entry or Exit Flow Graph Form Submission
        </h3>

        <ol class="ordered-list">
          <li>
            Select a Cohort (2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022,
            2023)
          </li>
          <li>Select a Category (College, Department, Program)</li>
          <li>Select a Direction (Forward, Backward)</li>
          <li>
            Select an Entry/Exit (Lewis Bear Jr College of Business; College of
            Arts, Social Sciences and Humanities; Usha Kundu, MD College of
            Health; Hal Marcus of College of Science and Engineering; School of
            Education; No College Designated)
          </li>
          <li>Select the range for High School GPA (0 - 5)</li>
          <li>
            Select a Year Range (From 1 to 2, From 2 to 3, From 3 to 4, From 4
            to end, From 1 to end)
          </li>
          <li>Click the submit button</li>
        </ol>
      </div>

      <div class="left-align-div">
        <p></p>
        <div>
          <img
            class="set-img-width-sm"
            [(src)]="env['logo_paths']['helpPageEntryExitFlow40']"
            alt=""
          />
          <p class="picture-caption">
            Figure 40: Default inputs for Exit or Entry Flow Graph form
          </p>
        </div>
      </div>

      <!--------------- Results After Form Submission Explanation --------------->
      <div class="left-align-div" id="results">
        <br />
        <mat-divider></mat-divider>
        <br />

        <h3 class="h3-second-header">Results after Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After submitting the form, you will see 1 Sankey graph like the
            screenshot (Figure 41) below. That shows you the exit or entry flow
            of students for the past years.
          </li>
          <li>
            You can also move the colored vertical bars around as you please.
          </li>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageEntryExitFlow41']"
              alt=""
            />
            <p class="picture-caption">
              Figure 41: Exit or Entry Flow Sankey Graph Result
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getAdminSupportRelatedLinkBasedOnTool(
        'Entry or Exit Flow Graph',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
